// extracted by mini-css-extract-plugin
export default {"root":"GroupItem_root__RqR1-","checkbox":"GroupItem_checkbox__aGQvo","icon":"GroupItem_icon__sV37N","name":"GroupItem_name__AzV4w","selected":"GroupItem_selected__ZFbmN"};